import { jsPDF } from "jspdf";
import * as pdfjsLib from "pdfjs-dist";

export const base64ToPdfFile = (base64, fileName = "cedula.pdf") => {
  const esPdf = base64.startsWith("data:application/pdf") || base64.startsWith("JVBER");
  if (esPdf) {
    const base64Limpio = base64.includes(",") ? base64.split(",")[1] : base64;
    const byteCharacters = atob(base64Limpio);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blobPdf = new Blob([byteArray], { type: "application/pdf" });
    return new File([blobPdf], fileName, { type: "application/pdf" });
  }
  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4"
  });

  // Detectar el tipo de imagen
  const formato = base64.startsWith("data:image/png") ? "PNG" : "JPEG";
  const imgProps = pdf.getImageProperties(base64);

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

  pdf.addImage(
    base64,
    formato,
    0,
    0,
    pdfWidth,
    pdfHeight
  );

  const blob = pdf.output("blob");

  return new File([blob], fileName, {
    type: "application/pdf"
  });
};

/*export const base64ToFile = (base64, fileName) => {
  const arr = base64.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: mime });
};*/
export const base64ToFile = async (base64, fileName) => {

    const arr = base64.split(',');

    const mime = arr[0].match(/:(.*?);/)[1];

    // ==========================================
    // SI YA ES JPG
    // ==========================================
    if (mime === "image/jpeg") {

        const bstr = atob(arr[1]);

        let n = bstr.length;

        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File(
            [u8arr],
            fileName,
            { type: "image/jpeg" }
        );
    }

    // ==========================================
    // SI ES PDF
    // ==========================================
    if (mime === "application/pdf") {

        const pdfData = atob(arr[1]);

        const pdfBytes = new Uint8Array(pdfData.length);

        for (let i = 0; i < pdfData.length; i++) {
            pdfBytes[i] = pdfData.charCodeAt(i);
        }

        const pdf = await pdfjsLib.getDocument({
            data: pdfBytes
        }).promise;

        // Obtener primera página
        const page = await pdf.getPage(1);

        // Calidad de la imagen
        const scale = 2;

        const viewport = page.getViewport({
            scale
        });

        // Crear canvas
        const canvas = document.createElement("canvas");

        const context = canvas.getContext("2d");

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        // Renderizar PDF en canvas
        await page.render({
            canvasContext: context,
            viewport
        }).promise;

        // Convertir canvas a JPG
        const blob = await new Promise((resolve, reject) => {

            canvas.toBlob(
                (result) => {
                    if (result) {
                        resolve(result);
                    } else {
                        reject(
                            new Error("No se pudo convertir el PDF a JPG")
                        );
                    }
                },
                "image/jpeg",
                0.90
            );

        });

        // Crear File REALMENTE JPG
        return new File(
            [blob],
            fileName,
            {
                type: "image/jpeg"
            }
        );
    }

    throw new Error(
        `Tipo de archivo no soportado: ${mime}`
    );
};

export const fusionarImagenesBase64 = (base64Frontal, base64Posterior) => {
  return new Promise((resolve, reject) => {
        const imgFrontal = new Image();
        const imgPosterior = new Image();
        let cargadas = 0;

        const alCargarImagen = () => {
            cargadas++;
            if (cargadas === 2) {
                const canvas = document.createElement('canvas');
                
                // Ancho máximo y altura combinada (una sobre otra)
                canvas.width = Math.max(imgFrontal.width, imgPosterior.width);
                canvas.height = imgFrontal.height + imgPosterior.height;

                const ctx = canvas.getContext('2d');

                // Fondo blanco en caso de diferencias de resolución
                ctx.fillStyle = '#FFFFFF';
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                // Dibujar frontal arriba y posterior abajo
                ctx.drawImage(imgFrontal, 0, 0);
                ctx.drawImage(imgPosterior, 0, imgFrontal.height);

                // Exportar la imagen fusionada a JPEG (calidad 90%)
                resolve(canvas.toDataURL('image/jpeg', 0.9));
            }
        };

        imgFrontal.onload = alCargarImagen;
        imgPosterior.onload = alCargarImagen;
        imgFrontal.onerror = (err) => reject("Error cargando imagen frontal: " + err);
        imgPosterior.onerror = (err) => reject("Error cargando imagen posterior: " + err);

        imgFrontal.src = base64Frontal;
        imgPosterior.src = base64Posterior;
    });
};

export const validarRenovacionFirma = async () => {
  var token = sessionStorage.getItem("access_token");
  if(token == null){
    token =  sessionStorage.getItem("token_nueva_cuenta");
  }
  if (!token) {
    throw new Error("No se encontró un token de acceso válido.");
  }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_FIRMAS}/FirmaElectronica/ValidarRenovacionDeFirmasByPersona`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        "Ocurrió un problema en el servidor de las firmas. Por favor, intenta nuevamente más tarde."
      );
    }

    const data = await response.json();

    if (!data.status?.isSuccessfully) {
      throw new Error("Error en el servicio de validación de renovación de firma.");
    }

    const habilitadoRenovar = Boolean(data.data?.habilitadoRenovar);

    return {
      habilitadoRenovar: habilitadoRenovar,
      mostrarMensajehabilitadoRenovar: !habilitadoRenovar
    };

  } catch (error) {
    let mensaje = error.message;
    if (mensaje === "Failed to fetch") {
      mensaje = "No fue posible conectarse al servidor de firmas. Verifique su conexión o CORS.";
    }
    throw new Error(mensaje);
  }
};